import store from 'store';

export const oemState = () => store?.getState()?.app.oemInfo?.oem ?? 'sync';
export const oemStatus = () => store?.getState()?.app.oemInfo?.status;
